<template>
  <div class="gl-root">
    <br/>
    <br v-if="!params.data.number" />
    <div v-if="params.data.number" class="gl-number">{{params.data.number}}</div>
    <br />
    <div v-if="params.data.name" class="gl-name">{{params.data.name}}</div>
  </div>
</template>

<script>

  export default {
    name: 'GLNameNumberCell',
    components: {
     
    },
    props: {

    },
    data: function () {
    
    },
    computed: {
    },
    methods: {
    },
    async mounted() {

    }
  }
</script>

<style lang="scss" scoped>
  .gl-name {
    font-size: 10px;
    white-space: pre-wrap;
    word-break: normal;
  }
  .gl-number {
    font-size: 14px;
    white-space: pre-wrap;
    word-break: normal;
  }
  .gl-name,
  .gl-number {
      line-height:16px;
      color: black !important;
      text-align:left;
  }
  .gl-root {
      line-height: 3px;
  }
</style>
